/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {MouseEventHandler} from 'react';
import {useTranslation} from 'react-i18next';

import IconWithLabel from '../../icon/iconWithLabel';

import Notification from '../../../models/notificationModel';

interface Props {
    onDeleteNotification: (notification: Notification) => MouseEventHandler;
    onSendTestNotification: (notification: Notification) => MouseEventHandler;
    disabled: boolean;
    notification: Notification;
    canDelete: boolean;
}

export default function NotificationActions(props: Props) {
    const {t} = useTranslation();
    const {onDeleteNotification, onSendTestNotification, disabled, notification, canDelete} = props;
    return (
        <div className='notification-actions-container'>
            {canDelete && (
                <IconWithLabel
                    label={t('notifications.components.deleteNotification', 'Notificatie verwijderen')}
                    name='trash-alt'
                    onClick={onDeleteNotification(notification)}
                    iconClassName='action btn-delete'
                />
            )}
            {!disabled && (
                <IconWithLabel
                    label={t('notifications.components.sendTestNotification', 'Test notificatie verzenden')}
                    name='paper-plane'
                    onClick={onSendTestNotification(notification)}
                    iconClassName='action btn-test'
                />
            )}
        </div>
    );
}
